// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1nrHk","name":"Header_name__1UjB_","birthday":"Header_birthday__2u3V0","skeleton":"Header_skeleton__3Jww3"};